import { render } from "./TipiScadenzaMezzo.vue?vue&type=template&id=0d36cfb4"
import script from "./TipiScadenzaMezzo.vue?vue&type=script&lang=js"
export * from "./TipiScadenzaMezzo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__